var render = function render(){var _vm=this,_c=_vm._self._c;return _c('b-row',[_c('b-col',{attrs:{"xs":"12","md":"1"}}),_c('b-col',{attrs:{"xs":"12","md":"10"}},[(_vm.numberOfResults >= 0)?_c('div',{staticClass:"search-stats"},[_c('p',[_vm._v("Results Found: "+_vm._s(_vm.numberOfResults))]),_c('hr',{staticClass:"result-title-content-border"})]):_vm._e()]),_c('b-col',{attrs:{"xs":"12","md":"1"}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }